import {Injectable} from 'ng-metadata/core';
import {PushtoService} from "../pushto.service";

@Injectable()
export class EasyBibService {
    private popupWin: Window;

    constructor(private pushtoService: PushtoService){

    }

    public easyBibAction(item, selectedIds){
            this.popupWin = window.open('', '_blank');
            let failedAction = angular.bind(this, this.failedPushtoAction);
            let successAction = angular.bind(this, this.successfullPushtoAction);
            let pushtoPromise = this.pushtoService.getServiceUrl([item], selectedIds, 'easybib');
            pushtoPromise.then((response)=>successAction(response), (response)=>failedAction(response));
    }

    private successfullPushtoAction(response) {
        let serviceUrl = response.data.serviceUrl;
        let data = response.data.data;
        
        this.popupWin.document.open();
        this.popupWin.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="document.getElementById(\'exportForm\').submit();"><FORM name="ExportForm" id="exportForm" method="POST" target="_parent"  style="display:none" action="' + serviceUrl + '">' + data + '</body>' + '</html>');
        this.popupWin.document.close();
        console.log("Easybib successfully sent");

    }

    private failedPushtoAction(event, response) {
        console.log("Easybib call failed");
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/easyBibAction/easyBib.service.ts